import React from "react";
import InputText from "../../../../atoms/InputText/InputText";

export default function UserId() {

    return (
        <div className="inputText-general">
            <InputText
                id={"userId"}
                label={"Nutzer-ID"}
                type={"text"}
                variant={"outlined"}
                placeholder={'test'}
            />
        </div>
    );
}

